export const prefixCountries = [
  { name: 'آذربایجان', latin_name: 'Azerbaijan', code: '994', code_name: 'AZ' },
  { name: 'آرژانتین', latin_name: 'Argentina', code: '54', code_name: 'AR' },
  { name: 'آفریقای جنوبی', latin_name: 'South Africa', code: '27', code_name: 'ZA' },
  { name: 'آفریقای مرکزی', latin_name: 'central african republic', code: '236', code_name: 'CF' },
  { name: 'آلبانی', latin_name: 'albania', code: '355', code_name: 'AL' },
  { name: 'آلمان', latin_name: 'Germany', code: '49', code_name: 'DE' },
  { name: 'آمریکا', latin_name: 'United States of America', code: '1', code_name: 'US' },
  { name: 'آنگولا', latin_name: 'angola', code: '244', code_name: 'AO' },
  { name: 'اتیوپی', latin_name: 'ethiopia', code: '251', code_name: 'ET' },
  { name: 'اتریش', latin_name: 'austria', code: '43', code_name: 'AT' },
  { name: 'اردن', latin_name: 'jordan', code: '962', code_name: 'JO' },
  { name: 'ارمنستان', latin_name: 'Armenia', code: '374', code_name: 'AM' },
  { name: 'اروگوئه', latin_name: 'uruguay', code: '598', code_name: 'UY' },
  { name: 'اریتره', latin_name: 'eritrea', code: '291', code_name: 'ER' },
  { name: 'ازبکستان', latin_name: 'uzbekistan', code: '998', code_name: 'UZ' },
  { name: 'اسپانیا', latin_name: 'Spain', code: '34', code_name: 'ES' },
  { name: 'استرالیا', latin_name: 'Australia', code: '61', code_name: 'AU' },
  { name: 'استونی', latin_name: 'Estonia', code: '372', code_name: 'EE' },
  { name: 'اطریش', latin_name: 'austria', code: '43', code_name: 'AT' },
  { name: 'افغانستان', latin_name: 'Afghanistan', code: '93', code_name: 'AF' },
  { name: 'الجزایر', latin_name: 'algeria', code: '213', code_name: 'DZ' },
  { name: 'السالوادور', latin_name: 'el salvador', code: '503', code_name: 'SV' },
  { name: 'امارات', latin_name: 'United Arab Emirates', code: '971', code_name: 'AE' },
  { name: 'اندونزی', latin_name: 'Indonesia', code: '62', code_name: 'ID' },
  { name: 'انگلستان', latin_name: 'England', code: '44', code_name: 'GB' },
  { name: 'اوگاندا', latin_name: 'uganda', code: '25', code_name: 'UG' },
  { name: 'اوکراین', latin_name: 'ukraine', code: '380', code_name: 'UA' },
  { name: 'ایتالیا', latin_name: 'Italy', code: '39', code_name: 'IT' },
  { name: 'ایران', latin_name: 'Iran', code: '98', code_name: 'IR' },
  { name: 'ایرلند', latin_name: 'Republic of Ireland', code: '353', code_name: 'IE' },
  { name: 'اکوادور', latin_name: 'ecuador', code: '593', code_name: 'EC' },
  { name: 'ایسلند', latin_name: 'Iceland', code: '354', code_name: 'IS' },
  { name: 'باربادوس', latin_name: 'Barbados', code: '1246', code_name: 'BB' },
  { name: 'باهاما', latin_name: 'bahamas', code: '1242', code_name: 'BS' },
  { name: 'بحرین', latin_name: 'bahrain', code: '973', code_name: 'BH' },
  { name: 'برزیل', latin_name: 'brazil', code: '55', code_name: 'BR' },
  { name: 'بروئنی', latin_name: 'brunei', code: '673', code_name: 'BN' },
  { name: 'بلاروس', latin_name: 'belarus', code: '375', code_name: 'BY' },
  { name: 'بلژیک', latin_name: 'belgium', code: '32', code_name: 'BE' },
  { name: 'بلغارستان', latin_name: 'bulgaria', code: '359', code_name: 'BG' },
  { name: 'بنگلادش', latin_name: 'bangladesh', code: '880', code_name: 'BD' },
  { name: 'بنین', latin_name: 'benin', code: '229', code_name: 'BJ' },
  { name: 'بوتان', latin_name: 'Bhutan', code: '267', code_name: 'Bhutan' },
  { name: 'بولیوی', latin_name: 'Bolivia', code: '591', code_name: 'BO' },
  { name: 'بوسنی و هرزگوین', latin_name: 'bosnia and herzegovina', code: '387', code_name: 'BA' },
  { name: 'تاجیکستان', latin_name: 'tajikistan', code: '992', code_name: 'TJ' },
  { name: 'تانزانیا', latin_name: 'tanzania', code: '255', code_name: 'TZ' },
  { name: 'تایلند', latin_name: 'Thailand', code: '66', code_name: 'TH' },
  { name: 'تایوان', latin_name: 'taiwan', code: '886', code_name: 'TW' },
  { name: 'ترینیداد', latin_name: 'trinidad island', code: '1868', code_name: 'TT' },
  { name: 'ترکمنستان', latin_name: 'turkmenistan', code: '993', code_name: 'TM' },
  { name: 'ترکیه', latin_name: 'Turkey', code: '90', code_name: 'TR' },
  { name: 'تونس', latin_name: 'Tunisia', code: '216', code_name: 'TN' },
  { name: 'تونگا', latin_name: 'Tonga', code: '676', code_name: 'TO' },
  { name: 'پاراگوئه', latin_name: 'paraguay', code: '595', code_name: 'PY' },
  { name: 'پاناما', latin_name: 'panama country', code: '507', code_name: 'PA' },
  { name: 'پاکستان', latin_name: 'pakistan', code: '92', code_name: 'PK' },
  { name: 'پرتغال', latin_name: 'portugal', code: '351', code_name: 'PT' },
  { name: 'پرو', latin_name: 'peru', code: '51', code_name: 'PE' },
  { name: 'پنال', latin_name: '', code: '95', code_name: 'no_flag' },
  { name: 'پورتوریکو', latin_name: 'Puerto Rico', code: '1939', code_name: 'PR' },
  { name: 'جامائیکا', latin_name: 'jamaica', code: '1876', code_name: 'JM' },
  { name: 'جزایر قناری', latin_name: 'Canary Islands', code: '359', code_name: 'canary' },
  { name: 'جزایرمارشال', latin_name: 'Marshall Islands', code: '692', code_name: 'MH' },
  { name: 'جی بو تی', latin_name: 'djibouti', code: '253', code_name: 'DJ' },
  { name: 'چاد', latin_name: 'chad africa', code: '235', code_name: 'TD' },
  { name: 'چین', latin_name: 'China', code: '86', code_name: 'CN' },
  { name: 'چک', latin_name: 'czech republic', code: '42', code_name: 'CZ' },
  { name: 'دانمارک', latin_name: 'denmark', code: '45', code_name: 'DK' },
  { name: 'دومینیکا', latin_name: 'dominica', code: '1767', code_name: 'DM' },
  { name: 'دومینیکن', latin_name: 'dominican republic', code: '1849', code_name: 'DO' },
  { name: 'رو آندا', latin_name: 'rwanda country', code: '250', code_name: 'RW' },
  { name: 'روسیه', latin_name: 'Russia', code: '7', code_name: 'RU' },
  { name: 'رومانی', latin_name: 'romania', code: '40', code_name: 'RO' },
  { name: 'زئیر', latin_name: 'democratic republic of the congo', code: '243', code_name: 'CD' },
  { name: 'زامبیا', latin_name: 'zambia', code: '260', code_name: 'ZM' },
  { name: 'زلاندنو', latin_name: 'New Zealand', code: '64', code_name: 'NZ' },
  { name: 'زیمبابوه', latin_name: 'zimbabwe', code: '263', code_name: 'ZW' },
  { name: 'ژاپن', latin_name: 'japan', code: '81', code_name: 'JP' },
  { name: 'ساحل عاج', latin_name: 'Côte d’Ivoire', code: '225', code_name: 'CI' },
  { name: 'ساموآ آمریکا', latin_name: 'American Samoa', code: '1684', code_name: 'AS' },
  { name: 'ساموا غربی', latin_name: 'Samoa', code: '685', code_name: 'WS' },
  { name: 'سریلانکا', latin_name: 'sri lanka', code: '94', code_name: 'LK' },
  { name: 'سنت لوسیا', latin_name: 'st lucia', code: '1758', code_name: 'LC' },
  { name: 'سنت وینسنت', latin_name: 'saint vincent and the grenadines', code: '1784', code_name: 'VC' },
  { name: 'سنت کیتس', latin_name: 'st kitts country', code: '1869', code_name: 'KN' },
  { name: 'سنگاپور', latin_name: 'singapore', code: '65', code_name: 'SG' },
  { name: 'سنگال', latin_name: 'senegal', code: '221', code_name: 'SN' },
  { name: 'سوئد', latin_name: 'Sweden', code: '46', code_name: 'SE' },
  { name: 'سوئیس', latin_name: 'switzerland', code: '41', code_name: 'CH' },
  { name: 'سودان', latin_name: 'sudan', code: '249', code_name: 'SD' },
  { name: 'سورینام', latin_name: 'Suriname', code: '597', code_name: 'SR' },
  { name: 'سوریه', latin_name: 'Syria', code: '963', code_name: 'SY' },
  { name: 'سومالی', latin_name: 'somalia', code: '252', code_name: 'SO' },
  { name: 'سیشل', latin_name: 'Seychelles', code: '148', code_name: 'SC' },
  { name: 'شیلی', latin_name: 'chile', code: '56', code_name: 'CL' },
  { name: 'صربستان و مونته نگرو', latin_name: 'Serbia and Montenegro', code: '381', code_name: 'RS' },
  { name: 'عراق', latin_name: 'Iraq', code: '964', code_name: 'IQ' },
  { name: 'عربستان', latin_name: 'saudi arabia', code: '966', code_name: 'SA' },
  { name: 'عمان', latin_name: 'Oman', code: '968', code_name: 'OM' },
  { name: 'غنا', latin_name: 'ghana', code: '233', code_name: 'GH' },
  { name: 'فرانسه', latin_name: 'France', code: '33', code_name: 'FR' },
  { name: 'فنلاند', latin_name: 'Finland', code: '358', code_name: 'FI' },
  { name: 'فیجی', latin_name: 'fiji', code: '679', code_name: 'FJ' },
  { name: 'فیلیپین', latin_name: 'philippines', code: '63', code_name: 'PH' },
  { name: 'قبرس', latin_name: 'Cyprus', code: '357', code_name: 'CY' },
  { name: 'قرقیزستان', latin_name: 'kyrgyzstan', code: '996', code_name: 'KG' },
  { name: 'قزاقزستان', latin_name: 'kazakhstan', code: '77', code_name: 'KZ' },
  { name: 'قطر', latin_name: 'Qatar', code: '974', code_name: 'QA' },
  { name: 'کامبوج', latin_name: 'cambodia', code: '855', code_name: 'KH' },
  { name: 'کامرون', latin_name: 'cameroon', code: '237', code_name: 'CM' },
  { name: 'کانادا', latin_name: 'Canada', code: '1', code_name: 'CA' },
  { name: 'کره جنوبی', latin_name: 'south korea', code: '82', code_name: 'KR' },
  { name: 'کره شمالی', latin_name: 'north korea', code: '850', code_name: 'KP' },
  { name: 'کرواسی', latin_name: 'croatia', code: '385', code_name: 'HR' },
  { name: 'کاستاریکا', latin_name: 'costa rica', code: '506', code_name: 'CR' },
  { name: 'کلمبیا', latin_name: 'colombia', code: '57', code_name: 'CO' },
  { name: 'کنگو', latin_name: 'Congo', code: '242', code_name: 'CG' },
  { name: 'کنیا', latin_name: 'kenya', code: '254', code_name: 'KE' },
  { name: 'کوبا', latin_name: 'cuba', code: '53', code_name: 'CU' },
  { name: 'کومور', latin_name: 'comoros', code: '269', code_name: 'KM' },
  { name: 'کویت', latin_name: 'kuwait', code: '965', code_name: 'KW' },
  { name: 'گابون', latin_name: 'Gabon', code: '241', code_name: 'GA' },
  { name: 'گامبیا', latin_name: 'gambia', code: '220', code_name: 'GM' },
  { name: 'گرجستان', latin_name: 'georgia country', code: '995', code_name: 'GE' },
  { name: 'گرنادا', latin_name: 'Grenada', code: '1473', code_name: 'GD' },
  { name: 'گوام', latin_name: 'guam', code: '1671', code_name: 'GU' },
  { name: 'گواتمالا', latin_name: 'guatemala', code: '502', code_name: 'GT' },
  { name: 'گینه', latin_name: 'guinea country', code: '224', code_name: 'GN' },
  { name: 'گینه استوایی', latin_name: 'equatorial guinea', code: '240', code_name: 'GQ' },
  { name: 'گینه بیسائو', latin_name: 'Guinea-Bissau', code: '245', code_name: 'GW' },
  { name: 'لائوس', latin_name: 'laos', code: '856', code_name: 'LA' },
  { name: 'لبنان', latin_name: 'Lebanon', code: '961', code_name: 'LB' },
  { name: 'لسوتو', latin_name: 'lesotho', code: '266', code_name: 'LS' },
  { name: 'لهستان', latin_name: 'poland', code: '48', code_name: 'PL' },
  { name: 'لوکزامبورگ', latin_name: 'luxembourg', code: '352', code_name: 'LU' },
  { name: 'لیبریا', latin_name: 'Liberia', code: '231', code_name: 'LR' },
  { name: 'لیبی', latin_name: 'libya', code: '218', code_name: 'LY' },
  { name: 'مالاوی', latin_name: 'Malawi', code: '265', code_name: 'MW' },
  { name: 'مالت', latin_name: 'malta', code: '356', code_name: 'MT' },
  { name: 'مالدیو', latin_name: 'maldives', code: '960', code_name: 'MV' },
  { name: 'مالزی', latin_name: 'Malaysia', code: '60', code_name: 'MY' },
  { name: 'مالی', latin_name: 'mali', code: '223', code_name: 'ML' },
  { name: 'مجارستان', latin_name: 'hungary', code: '36', code_name: 'HU' },
  { name: 'مراکش', latin_name: 'morocco', code: '212', code_name: 'MA' },
  { name: 'مصر', latin_name: 'Egypt', code: '20', code_name: 'EG' },
  { name: 'مغولستان', latin_name: 'mongolia', code: '976', code_name: 'MN' },
  { name: 'مقدونیه', latin_name: 'macedonia', code: '389', code_name: 'MK' },
  { name: 'موریتانی', latin_name: 'mauritania', code: '222', code_name: 'MR' },
  { name: 'موریس', latin_name: 'mauritius', code: '230', code_name: 'MU' },
  { name: 'موزامبیک', latin_name: 'Mozambique', code: '258', code_name: 'MZ' },
  { name: 'میانمار', latin_name: 'myanmar', code: '95', code_name: 'MM' },
  { name: 'مکزیک', latin_name: 'mexico', code: '52', code_name: 'MX' },
  { name: 'نائورا', latin_name: 'Nauru', code: '674', code_name: 'NR' },
  { name: 'نامیبیا', latin_name: 'Namibia', code: '264', code_name: 'NA' },
  { name: 'نپال', latin_name: 'Nepal', code: '977', code_name: 'NP' },
  { name: 'نروژ', latin_name: 'norway', code: '47', code_name: 'NO' },
  { name: 'نگارا پرونئی دارالسلام', latin_name: '', code: '267', code_name: 'no_flag' },
  { name: 'نیجر', latin_name: 'niger', code: '227', code_name: 'NE' },
  { name: 'نیکاراگوئه', latin_name: 'nicaragua', code: '505', code_name: 'NI' },
  { name: 'هائی تی', latin_name: 'haiti country', code: '509', code_name: 'HT' },
  { name: 'هلند', latin_name: 'Netherlands', code: '31', code_name: 'NL' },
  { name: 'هند', latin_name: 'India', code: '91', code_name: 'IN' },
  { name: 'هندوراس', latin_name: 'Honduras', code: '504', code_name: 'HN' },
  { name: 'هنگ کنگ', latin_name: 'hong kong', code: '852', code_name: 'HK' },
  { name: 'واتیکان', latin_name: 'vatican city', code: '39', code_name: 'VA' },
  { name: 'ونزوئلا', latin_name: 'venezuela', code: '58', code_name: 'VE' },
  { name: 'ویتنام', latin_name: 'vietnam', code: '84', code_name: 'VN' },
  { name: 'یمن جنوبی', latin_name: 'South Yemen', code: '969', code_name: 's_yemen' },
  { name: 'یمن شمالی', latin_name: 'North Yemen', code: '967', code_name: 'YE' },
  { name: 'یوگسلاوی', latin_name: 'Yugoslavia', code: '381', code_name: 'yu' },
  { name: 'یونان', latin_name: 'greece', code: '30', code_name: 'GR' },
];
